<template>
  <div class="row">
    <div class="col-12">
      <form class="form-horizontal" @submit.prevent="handleSubmit">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              Land Title Registration
            </h4>
          </div>
          <div class="card-body card-blue">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="case_number">Case Number</label>
                  <div class="col-sm-8 text-left">
                    <input id="case_number" v-model="title.case_number" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('case_number')}" class="form-control" data-vv-as="Case Number" name="case_number" type="text">
                    <div v-if="submitted && errors.has('case_number')" class="invalid-feedback">
                      {{ errors.first('case_number') }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="org" class="col-sm-4 text-right control-label col-form-label">Owner</label>
                  <div class="col-sm-8 text-left">
                    <multiselect id="org" v-model="selectedOwner" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('org')}" :clear-on-select="true" :close-on-select="true" :hide-selected="true" :internal-search="false" :limit="5" :max-height="600" :multiple="false" :options="orgs" :options-limit="300" :searchable="true" :show-no-results="false" label="name" name="org" class="form-control" placeholder="Select Title Owner" track-by="id" @search-change="getOwners" @input="setOwner">
                      <template slot="singleLabel" slot-scope="props">
                        <div class="option__desc">
                          <div class="option__desc">
                            <h6>{{ props.option.name }}</h6>
                          </div>
                        </div>
                      </template>
                      <template slot="option" slot-scope="props">
                        <div class="option__desc">
                          <div class="option__desc">
                            <h6>{{ props.option.name }}</h6>
                          </div>
                        </div>
                      </template>
                    </multiselect>
                    <div v-if="submitted && errors.has('org')" class="invalid-feedback">
                      {{ errors.first('org') }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="description">Description</label>
                  <div class="col-sm-8 text-left">
                    <textarea id="description" v-model="title.description" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('description')}" class="form-control" data-vv-as="Description" name="description" />
                    <div v-if="submitted && errors.has('description')" class="invalid-feedback">
                      {{ errors.first('description') }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="coords">Coordinates</label>
                  <div class="col-sm-8 text-left">
                    <input id="coords" v-model="title.coords.geometry.coordinates" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('coords')}" class="form-control" data-vv-as="Coordinates" name="coords" type="text" @change="setCoordinates">
                    <div v-if="submitted && errors.has('coords')" class="invalid-feedback">
                      {{ errors.first('coords') }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-sm-12">
                    <label class="control-label col-form-label">Notes</label>
                    <document-editor :editor-size="'SMALL'" @input="getDataFromEditor" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div id="map" class="card-body card-blue" />
              </div>
            </div>

            <hr>

            <div class="row m-t-10">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-6">
                    <label class="control-label">Primary Witnesses</label>
                  </div>
                  <div class="col-sm-6 text-right">
                    <button class="btn btn-success waves-effect" type="button" data-toggle="modal" data-target="#witnessModal" :disabled="title.witnesses.length >= 4">
                      <i class="fa fa-user-plus" /> Add
                    </button>
                  </div>
                </div>
              </div>

              <div class="col-md-12 m-t-10 table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Witness Name</th>
                      <th>Address</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="title.witnesses.length === 0" class="text-center">
                      <td colspan="4" class="font-weight-bold">
                        No Witness Added
                      </td>
                    </tr>
                    <tr v-for="(w, index) in title.witnesses" v-if="title.witnesses.length > 0" :key="index">
                      <td>{{ index+1 }}</td>
                      <td>{{ w.name }}</td>
                      <td>{{ w.address }}</td>
                      <td>
                        <a href="javascript:void(0)" class="text-danger" @click="removeWitness(index)"><i class="fa fa-trash" /></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <hr>

            <div class="row m-t-10">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-6">
                    <label class="control-label">Uploaded Documents</label>
                  </div>
                  <div class="col-sm-6 text-right">
                    <button class="btn btn-success waves-effect" type="button" data-toggle="modal" data-target="#attachmentModal">
                      <i class="fa fa-paperclip" /> Upload
                    </button>
                  </div>
                </div>
              </div>

              <div class="col-md-12 m-t-10 table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Document</th>
                      <th>Description</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="title.attachments.length === 0" class="text-center">
                      <td colspan="4" class="font-weight-bold">
                        No Documents Uploaded
                      </td>
                    </tr>
                    <tr v-for="(a, index) in title.attachments" v-if="title.attachments.length > 0" :key="index">
                      <td>{{ index+1 }}</td>
                      <td>{{ a.filename }}</td>
                      <td>{{ a.description }}</td>
                      <td>
                        <a href="javascript:void(0)" class="text-danger" @click="removeDocument(index)"><i class="fa fa-trash" /></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <hr>

            <div class="row m-t-10">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-6">
                    <label class="control-label">Title Attributes</label>
                  </div>
                  <div class="col-sm-6 text-right">
                    <button class="btn btn-success waves-effect" type="button" data-toggle="modal" data-target="#attributeModal">
                      <i class="fa fa-plus" /> Add
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-12 m-t-10 table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Attribute Name</th>
                      <th>Description</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="title.attributes.length === 0" class="text-center">
                      <td colspan="4" class="font-weight-bold">
                        No Attributes Added
                      </td>
                    </tr>
                    <tr v-for="(p, index) in title.attributes" v-if="title.attributes.length > 0" :key="index">
                      <td>{{ index+1 }}</td>
                      <td>{{ p.name }}</td>
                      <td>{{ p.description }}</td>
                      <td>
                        <a href="javascript:void(0)" class="text-danger" @click="removeAttribute(index)"><i class="fa fa-trash" /></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="form-group m-b-0 text-right">
              <div class="button-group">
                <button class="btn waves-effect waves-light btn-success" type="submit" :disabled="submitted">
                  Save
                </button>
                <button class="btn waves-effect waves-light btn-secondary" type="button" @click="reset()">
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div id="witnessModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              Title Attribute
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
              ×
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <input id="witness_name" v-model="witness_name" type="text" name="attribute_name" class="form-control" placeholder="Witness Name">
              </div>
            </div>
            <div class="row m-t-10">
              <div class="col-sm-12">
                <textarea id="witness_address" v-model="witness_address" name="attribute_desc" cols="30" rows="5" class="form-control" placeholder="Witness Address" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success waves-effect" @click="addWitness">
              Save
            </button>
            <button type="button" class="btn btn-danger waves-effect waves-light" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <div id="attachmentModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              Upload Document
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
              ×
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <input id="attachment" ref="attachment" type="file" name="attachment" class="form-control-file" @change="handleFileChange">
              </div>
            </div>
            <div class="row m-t-10">
              <div class="col-sm-12">
                <textarea id="attachment_desc" v-model="attachment_desc" name="attachment_desc" cols="30" rows="5" class="form-control" placeholder="Document Description" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success waves-effect" @click="addDocument">
              Save
            </button>
            <button type="button" class="btn btn-danger waves-effect waves-light" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <div id="attributeModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              Title Attribute
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
              ×
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <input id="attribute_name" v-model="attribute_name" type="text" name="attribute_name" class="form-control" placeholder="Attribute Name">
              </div>
            </div>
            <div class="row m-t-10">
              <div class="col-sm-12">
                <textarea id="attribute_desc" v-model="attribute_desc" name="attribute_desc" cols="30" rows="5" class="form-control" placeholder="Document Description" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success waves-effect" @click="addAttribute">
              Save
            </button>
            <button type="button" class="btn btn-danger waves-effect waves-light" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import DocumentEditor from '../common/DocumentEditor.vue';
import axios from 'axios';

export default {
  name: 'Register',
  components: { Multiselect, DocumentEditor },
  data() {
    return {
      submitted: false,
      orgs: [],
      selectedOwner: null,
      title: {
        case_number: null,
        description: null,
        title_owner_id: null,
        title_owner_type: null,
        coords: {
          type: 'Feature',
          properties: {
            popupContent: 'New Land'
          },
          geometry: { coordinates: null }
        },
        notes: null,
        witnesses: [],
        attachments: [],
        attributes: []
      },
      attachment: null,
      attachment_desc: null,
      attribute_name: null,
      attribute_desc: null,
      witness_name: null,
      witness_address: null,
      map: null,
      tileLayer: null,
      marker: null,
      layers: [],
      properties: []
    };
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  mounted() {
    this.initDrawMap();
  },
  methods: {
    initDrawMap() {
      this.map = L.map('map').setView([38.63, -90.23], 12);
      // Set up the OSM layer
      this.tileLayer = L.tileLayer(
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: 'Data © <a href="http://osm.org/copyright">OpenStreetMap</a>',
        maxZoom: 18
      });
      this.map.addLayer(this.tileLayer);
      this.map.locate({ setView: true });

      // Initialise the FeatureGroup to store editable layers
      const editableLayers = new L.FeatureGroup();
      this.map.addLayer(editableLayers);
      this.layers.push(editableLayers);
      const drawPluginOptions = {
        position: 'topright',
        draw: {
          polygon: {
            allowIntersection: false, // Restricts shapes to simple polygons
            // allowSelfIntersection: false,
            drawError: {
              color: '#e1e100', // Color the shape will turn when intersects
              message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
            },
            shapeOptions: {
              color: '#97009c'
            }
          },
          // disable toolbar item by setting it to false
          polyline: false,
          circle: false, // Turns off this drawing tool
          rectangle: false,
          marker: false
        },
        edit: false
      };
      const drawEditOptions = {
        position: 'topright',
        draw: false,
        edit: {
          featureGroup: editableLayers, // REQUIRED!!
          remove: true
        }
      };
      this.initJsonLayer();

      // Initialise the draw control and pass it the FeatureGroup of editable layers
      const drawControl = new L.Control.Draw(drawPluginOptions);
      const drawEdit = new L.Control.Draw(drawEditOptions);
      this.map.addControl(drawControl);

      // var editableLayers = new L.FeatureGroup();
      // this.map.addLayer(editableLayers);

      this.map.on('draw:created', (e) => {
        const type = e.layerType;
        const layer = e.layer;

        if (type === 'marker') {
          layer.bindPopup('your cluster');
        }

        editableLayers.addLayer(layer);
        drawControl.remove(this.map);
        drawEdit.addTo(this.map);
        this.title.coords = layer.toGeoJSON();
      });
      this.map.on('draw:deleted', (e) => {
        this.title.coords = '';
        drawEdit.remove(this.map);
        drawControl.addTo(this.map);
      });
    },
    initJsonLayer() {
      if (this.title.coords.geometry.coordinates) {
        const jsonLayer = L.geoJson(this.title.coords, { color: 'green' });
        jsonLayer.addTo(this.map);
        this.map.fitBounds(jsonLayer.getBounds());
      }
    },
    setCoordinates() {
      if (typeof (this.title.coords.geometry.coordinates) === 'string') {
        const coords = (this.title.coords.geometry.coordinates).split(',');
        if (coords.length % 2 !== 0) {
          this.$toastr('warning', 'Invalid Coordinates Format', 'Warning');
        } else {
          const formated = [];
          for (let i = 0; i < coords.length;) {
            formated.push([coords[i].trim(), coords[i + 1].trim()]);
            i = i + 2;
          }
          this.title.coords.geometry.type = 'Polygon';
          this.title.coords.geometry.coordinates = [];
          this.title.coords.geometry.coordinates.push(formated);
          // console.log(this.title.coords);
          // this.initMap()
          this.initJsonLayer();
        }
      }
    },
    getDataFromEditor(event) {
      this.title.notes = event;
    },
    async getOwners(searchText) {
      const response = await this.$api.get('/land-title/owner/search', {
        params: {
          searchText: searchText
        }
      });
      this.orgs = response.data;
    },
    setOwner(owner) {
      this.selectedOwner = owner;
      this.title.title_owner_id = owner.id;
      this.title.title_owner_type = owner.type;
    },
    handleFileChange() {
      this.attachment = this.$refs.attachment.files[0];
    },
    async addDocument() {
      const urlObj = await this.getUploadUrl(this.attachment.name, this.attachment.type.split('/')[1]);
      await this.uploadDocument(urlObj.url, this.attachment);

      this.title.attachments.push({
        document_id: urlObj.documentid,
        filename: this.attachment.name,
        filepath: urlObj.key,
        description: this.attachment_desc
      });

      this.$refs.attachment.value = '';
      this.attachment = null;
      this.attachment_desc = null;
      $('#attachmentModal').modal('toggle');
    },
    async getUploadUrl(filename, filetype) {
      const response = await this.$api.get('/land-title/signedUrl', {
        params: {
          filename,
          contenttype: filetype,
          type: 'write'
        }
      });

      return response.data;
    },
    async uploadDocument(url, attachment) {
      await axios.put(url, attachment);
    },
    addWitness() {
      this.title.witnesses.push({
        name: this.witness_name,
        address: this.witness_address
      });
      this.witness_name = null;
      this.witness_address = null;
      $('#witnessModal').modal('toggle');
    },
    addAttribute() {
      this.title.attributes.push({
        name: this.attribute_name,
        description: this.attribute_desc
      });
      this.attribute_name = null;
      this.attribute_desc = null;
      $('#attributeModal').modal('toggle');
    },
    removeDocument(index) {
      const document = this.title.attachments[index];
      // remove file from S3 bucket
      this.title.attachments.splice(index, 1);
    },
    removeWitness(index) {
      this.title.witnesses.splice(index, 1);
    },
    removeAttribute(index) {
      this.title.properties.splice(index, 1);
    },
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate()
        .then(valid => {
          if (valid) {
            if (this.title.witnesses.length === 0) {
              this.$toastr('warning', 'Minimum of one witness is required', 'Warning');
              this.submitted = false;
            } else {
              this.save();
            }
          }
        });
    },
    async save() {
      // console.log(this.title);
      try {
        this.submitted = true;
        const reply = await this.$api.post('/land-title', this.title);
        this.$toastr(reply.status === 206 ? 'warning' : 'success',
          reply.status === 206 ? reply.data.message : 'Successfully approved', 'Approved');
        // this.reset();
        window.location.reload();
      } catch (e) {
        this.$toastr('error', 'Land Title Registration Failed', 'Failed');
      }
    }
  }
}
</script>

<style scoped>
#map {
  width: 100%;
  height: 500px;
}
</style>
